export default __webpack_public_path__ + "static/media/Group 49.0e3bc45f.jpg";